export const MAX_PHOTO_SIZE = 20000000;
export const PHOTO_ACCEPT = '.jpg,.jpeg,.png,.gif,image/jpeg,image/png,image/gif';

const imageTypes = {jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif'};
const extensions = {'image/jpeg': 'jpg', 'image/png': 'png', 'image/gif': 'gif'};
const mimeAliases = {'image/jpg': 'image/jpeg', 'image/pjpeg': 'image/jpeg', 'image/x-png': 'image/png'};

function photoType(file) {
    const extension = (file.name || '').match(/\.([^.]+)$/)?.[1].toLowerCase() || '';
    const reportedMime = (file.type || '').toLowerCase();
    const mime = mimeAliases[reportedMime] || reportedMime;
    const extensionMime = Object.prototype.hasOwnProperty.call(imageTypes, extension) ? imageTypes[extension] : null;
    const supportedMime = Object.prototype.hasOwnProperty.call(extensions, mime);
    const genericMime = !mime || mime === 'application/octet-stream';
    return (extensionMime && (genericMime || mime === extensionMime)) || (!extension && supportedMime)
        ? extensionMime || mime
        : null;
}

export function validatePhotoFile(file) {
    if (!file) return 'NO_FILE';
    if (!file.size) return 'EMPTY_FILE';
    if (file.size > MAX_PHOTO_SIZE) return 'LIMIT_FILE_SIZE';
    if (!photoType(file)) return 'UNSUPPORTED_FILE_TYPE';
    return null;
}

export function photoFormData(file, funeral, tag) {
    const data = new FormData();
    const mime = photoType(file);
    if (!mime) throw Object.assign(new Error('Unsupported image type'), {code: 'UNSUPPORTED_FILE_TYPE'});
    const prefix = (funeral.d_id || '').split('/').join('');
    // Give extensionless mobile files and canvas-generated blobs a matching filename and MIME type.
    const image = file.type === mime ? file : new Blob([file], {type: mime});
    data.append('someimage', image, `${prefix}_${tag}.${extensions[mime]}`);
    data.append('funeral_id', funeral._id);
    data.append('tag', tag);
    return data;
}

export function photoUploadErrorMessage(error) {
    const response = error?.response;
    const failure = response?.data?.error || error;
    const code = typeof failure === 'string' ? failure : failure?.code;
    if (code === 'UNSUPPORTED_FILE_TYPE' || code === 'Error: Images Only!' || response?.status === 415) {
        return 'Nepodporovan\u00fd form\u00e1t. Pou\u017eite JPG, PNG alebo GIF. In\u00fd form\u00e1t najprv exportujte ako JPG alebo PNG.';
    }
    if (code === 'LIMIT_FILE_SIZE' || response?.status === 413) {
        return 'S\u00fabor je pr\u00edli\u0161 ve\u013ek\u00fd. Maxim\u00e1lna ve\u013ekos\u0165 je 20 MB.';
    }
    if (code === 'NO_FILE') return 'Najprv vyberte fotku alebo sken dokumentu.';
    if (code === 'EMPTY_FILE') return 'Vybran\u00fd s\u00fabor je pr\u00e1zdny. Vyberte in\u00fd s\u00fabor.';
    if (code === 'IMAGE_PROCESSING_FAILED') return 'Fotku sa nepodarilo spracova\u0165. Sk\u00faste ju exportova\u0165 ako JPG alebo PNG.';
    if (response?.status === 403) return 'Na nahr\u00e1vanie dokumentov nem\u00e1te opr\u00e1vnenie.';
    if (response?.status === 404) return 'Z\u00e1znam sa nena\u0161iel. Obnovte str\u00e1nku a sk\u00faste to znova.';
    if (!response && error instanceof Error && (!code || ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(code))) {
        return 'Nahr\u00e1vanie sa preru\u0161ilo. Skontrolujte pripojenie a sk\u00faste to znova.';
    }
    return 'Dokument sa nepodarilo nahra\u0165. Sk\u00faste to znova nesk\u00f4r.';
}
